import styles from './comments-header.module.scss';
import { unreachable } from '../../../ts-utils';
const classes = styles;
/*
  Desktop layout:

    "areaA empty"
    "areaB areaC"

  Mobile layout:

    "areaA areaB"
    "areaC empty"

  If only two elements are rendered, we switch to one row layout for both mobile and desktop:

    "areaA areaB"
*/
export const resolveElementAreaClasses = ({ isMobile, isTitleVisible, isRatingVisible, isUserAuthVisible, }) => {
    if (isMobile) {
        return {
            titleArea: classes.areaA,
            ratingArea: !isTitleVisible
                ? classes.areaA
                : isUserAuthVisible
                    ? classes.areaC
                    : classes.areaB,
        };
    }
    else {
        return {
            titleArea: classes.areaA,
            ratingArea: !isTitleVisible ? classes.areaA : classes.areaB,
            userAuthArea: isTitleVisible && isRatingVisible ? classes.areaC : classes.areaB,
        };
    }
};
// As we need the header visibility inside rootBox this can not become a part of component - it
// has to be resolved higher up the component tree
export const resolveHeaderVisibility = ({ hideHeader, hideTitle, hideRatings, userAuthControlState, }) => hideHeader || (hideTitle && hideRatings && userAuthControlState.type === 'HIDDEN')
    ? { type: 'HIDDEN' }
    : {
        type: 'VISIBLE',
        visibilityProps: {
            userAuthControlState,
            hideTitle: !!hideTitle,
            hideRatings: !!hideRatings,
        },
    };
export const resolveUserAuthControlState = (displayConfig = 'LOGOUT_ONLY', currentMember) => {
    switch (displayConfig) {
        case 'NONE':
            return { type: 'HIDDEN' };
        case 'LOGOUT_ONLY':
            return currentMember
                ? {
                    type: 'LOGOUT',
                    memberAvatarUrl: currentMember.profile.photo?.url,
                    memberName: currentMember.profile.nickname ?? undefined,
                }
                : { type: 'HIDDEN' };
        case 'LOGIN_AND_LOGOUT':
            return currentMember
                ? {
                    type: 'LOGOUT',
                    memberAvatarUrl: currentMember.profile.photo?.url,
                    memberName: currentMember.profile.nickname ?? undefined,
                }
                : { type: 'LOGIN' };
        default:
            throw unreachable(displayConfig);
    }
};
//# sourceMappingURL=comments-header-utils.js.map